import React from "react";
import RFPForm from "./RFPForm";

function App() {
  return <RFPForm />;
}

export default App;


